import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { setPin, verifyPin, errorText } from "@/lib/family";

export const PinGate = ({ hasPin, onUnlock }) => {
  const [pin, setVal] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\d{4}$/.test(pin)) return toast.error("PIN must be 4 digits");
    if (!hasPin && pin !== confirm) return toast.error("PINs don't match");
    setBusy(true);
    try {
      await (hasPin ? verifyPin(pin) : setPin(pin));
      onUnlock(pin);
    } catch (err) {
      toast.error(errorText(err));
      setVal("");
    }
    setBusy(false);
  };

  const digits = (v) => v.replace(/\D/g, "").slice(0, 4);
  return (
    <form className="pp-card max-w-md" onSubmit={submit} data-testid="pin-gate-form">
      <span className="pp-lock ok"><Lock className="h-6 w-6" /></span>
      <h2 className="pp-h2 mt-4">{hasPin ? "Enter your parent PIN" : "Create a 4-digit parent PIN"}</h2>
      <p className="pp-sub text-sm">
        {hasPin ? "Only grown-ups can manage children and history." : "You'll need it to add or remove children and clear history."}
      </p>
      <input className="pp-input pp-pin" type="password" inputMode="numeric" autoComplete="off" placeholder="••••"
        value={pin} onChange={(e) => setVal(digits(e.target.value))} data-testid="pin-input" />
      {!hasPin && (
        <input className="pp-input pp-pin" type="password" inputMode="numeric" autoComplete="off" placeholder="Confirm"
          value={confirm} onChange={(e) => setConfirm(digits(e.target.value))} data-testid="pin-confirm-input" />
      )}
      <button className="pp-primary mt-5" disabled={busy} data-testid="pin-submit-button">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : hasPin ? "Unlock" : "Save PIN"}
      </button>
    </form>
  );
};
